/* eslint no-extend-native: "off" */
// TODO: We should see if we can change the code that uses these.

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

String.prototype.interpolateObject = function (obj, transformer) {
  let interpolated = this

  Object.entries(obj).map(function (pair) {
    const regexp = new RegExp("{{" + pair[0] + "}}", "g")
    interpolated = interpolated.replace(regexp, transformer ? transformer(pair[1]) : pair[1])
  })

  return interpolated
}

Date.prototype.humanize = function(includeDay = true) {
  const date = this.getDate().toString()

  return this.monthNames()[this.getMonth()] + (includeDay ? " " + date + ", " : " ") + this.getFullYear().toString()
}

Date.prototype.monthNames = function() {
  return [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}
